// extracted by mini-css-extract-plugin
export default {"warning-tags__input":"WarningTagsInput_warning-tags__input__dAQFg"};